import React from 'react'

function Avviso() {
	return (
		<>
			{new Date() < new Date('2026/08/25') && (
				<div className="avviso">
					<div className="titolo_avviso">
						<b>Pausa estiva</b>
						{/* <b>Pausa Natalizia</b> */}
					</div>
					<div className="testo_avviso">
						Le spedizioni dei premi saranno interrotte dal <b>10/08/2026</b> al <b>23/08/2026</b> inclusi e riprenderanno regolarmente a partire dal <b>24/08/2026</b>.
						<br />
						Tutti i prodotti ordinati dal <b>10/08/2026</b> saranno quindi regolarmente spediti dal <b>24/08/2026</b>.
					</div>
				</div>
			)}
		</>
	)
}

export default Avviso
